import React from 'react'
import { Button } from '@connectcore/connect-components-react'

const TermsAndConditions = ({ setShowTerms }) => {
  return (
    <div className="terms-and-conditions" data-testid="TermsAndConditions">
      <div className="heading">
        <p>Mobile Terms & Conditions</p>
        <p>JPMC - IT RISK SEC & MGT GTI</p>
        <p>Terms and Conditions</p>
        <p>For text messages providing alerts and/or notices</p>
      </div>
      <p>
        You have subscribed and expressly consented to receive text messages (1 message per request)
        on your mobile telecommunications device from JP Morgan Chase for purposes of providing you
        with notices and/or alerts regarding your related account with us. You acknowledge,
        understand, and agree as follows: Message and Data rates may apply. These would be charged
        by, and be payable by you to, your mobile service provider. You acknowledge, understand, and
        agree that we shall not be held liable for any delays in the receipt of our text message to
        you, as its delivery is subject to effective transmission from your mobile service provider.
        In addition, if you decide you no longer want to subscribe, you can respond to any text
        alert, notice, and/or promotional offer you receive by texting the word <b>STOP</b> and
        replying to the message at 72152. Messages sent via SMS may not be delivered to you if your
        phone is not in range of a transmission site, or if sufficient network capacity is not
        available at a particular time. Even within a coverage area, factors beyond the control of
        your wireless carrier may interfere with the message delivery, including the customer&apos;s
        equipment, terrain, proximity to buildings, foliage, and weather. You acknowledge that
        urgent alerts may not be timely received and that your wireless carrier does not guarantee
        that alerts will be delivered. Content may not be available on all carriers. Participating
        carriers are ACG, ALL TEL/AWC, AT&T Mobility, Boost, Cincinnati Bell, Metro PCS, Nextel,
        Rural Carrier Groups, Sprint, Tier 2/3 Group, T-Mobile, U.S. Cellular, Verizon Wireless,
        Virgin Mobile. Data obtained by us from you in connection with our providing you the text
        messages as described above may include your cellular number, the name of your mobile
        service provider, and the date, time, and content of the text messages we send you. We may
        use this information to contact you and to provide the text messages you have requested. If
        you have any questions regarding the above terms or the types of text messages to be
        received by you as described above, then you can respond to any such message you receive by
        texting the word <b>HELP</b> and replying to the message at 72152. Or, you can contact
        1-800-345-2345.
      </p>
      <br />
      <Button
        kind="primary"
        onClick={e => {
          e.preventDefault()
          setShowTerms(false)
        }}
      >
        Back
      </Button>
    </div>
  )
}

export default TermsAndConditions
